import { Checkbox, Form, Select } from 'antd';
import { SelectProps } from 'antd/lib';

import { TFieldProps } from 'types';

import { handleClickSelectAll } from './lib';

const { Item } = Form;

interface ICustomSelect extends Omit<TFieldProps, 'value' | 'onChange' | 'type'> {
  value?: string[];
  onChange?: SelectProps['onChange'];
}

export const CustomSelect = ({
  name,
  mode,
  value,
  loading,
  options = [],
  disabled,
  className,
  showSearch = true,
  allowClear = true,
  fieldNames,
  inputStyles,
  placeholder,
  maxTagCount,
  onChange,
  onDeselect,
  optionRender,
  onSelectChange,
}: ICustomSelect) => {
  const allKeys = options.map((option) => option.value) as string[];

  return (
    <Select
      id={name.toString()}
      value={value}
      onChange={(val, option) => {
        onChange?.(val, option);
        onSelectChange?.(val, option);
      }}
      mode={mode}
      loading={loading}
      options={options}
      style={inputStyles}
      disabled={disabled}
      className={className}
      showSearch={showSearch}
      allowClear={allowClear}
      fieldNames={fieldNames}
      placeholder={placeholder}
      maxTagCount={maxTagCount}
      onDeselect={onDeselect}
      optionRender={optionRender}
      popupMatchSelectWidth={false}
      filterOption={(input, option) => String(option?.label).includes(input)
        || String(option?.label).toLowerCase().includes(input)}
      dropdownRender={(node) => {
        if (mode === 'multiple') {
          return (
            <>
              <Checkbox
                onChange={handleClickSelectAll({ allKeys, value, onSelectChange, onChange })}
                checked={value?.length === allKeys.length}
                className='ml-1 mb-3'
                title='Select All'
              >
                Select All
              </Checkbox>

              {node}
            </>
          );
        }

        return node;
      }}
    />
  );
};

export const FormSelect = ({
  name,
  mode,
  label,
  rules,
  extra,
  tooltip,
  loading,
  options,
  disabled,
  className,
  showSearch = true,
  allowClear = true,
  fieldNames,
  inputStyles,
  placeholder,
  maxTagCount,
  itemClassName,
  normalize,
  tagRender,
  onDeselect,
  optionRender,
  onSelectChange,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    extra={extra}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    normalize={normalize}
  >
    <CustomSelect
      name={name}
      mode={mode}
      loading={loading}
      options={options}
      style={inputStyles}
      disabled={disabled}
      className={className}
      showSearch={showSearch}
      allowClear={allowClear}
      fieldNames={fieldNames}
      placeholder={placeholder}
      maxTagCount={maxTagCount}
      tagRender={tagRender}
      onDeselect={onDeselect}
      optionRender={optionRender}
      onSelectChange={onSelectChange}
    />
  </Item>
);
